export interface ChartSeats {
  selectedObjects: string[];
  holdToken: string;
}

interface CategorySeats {
  label: string;
  key: number;
  color: string;
}

export interface SingleSectorPricing {
  formattedPrice: string;
  price: number;
}

export interface TicketTypeOption {
  price: number;
  ticketType: string;
  label: string;
  formattedPrice: string;
  mandatory?: boolean;
}

interface MultiLevelPricing {
  ticketTypes: TicketTypeOption[];
}

export type SeatPricing = SingleSectorPricing | MultiLevelPricing;

export function isMultiLevelPricing(pricing: SeatPricing): pricing is MultiLevelPricing {
  return 'ticketTypes' in pricing;
}

export interface SeatsOjectMethods {
  deselect: (ticketType?: string) => Promise<void>;
}

export interface GASeatsPartial extends SeatsOjectMethods {
  label: string;
  chart: ChartSeats;
  category: CategorySeats;
  pricing: SeatPricing;
  selectedTicketType?: string;
  selectionPerTicketType?: Record<string, number>;
  entrance: string;
}

export interface SessionInitialized {
  token: string;
  expiresAt: string;
  expiresInSeconds: number;
}
